import { useQuery } from '@tanstack/react-query';

import { fetchTermsPdf, TERMS_PDF_URL } from '@services/termsPdfService';

const TERMS_PDF_QUERY_KEY = 'termsAndConditionsPdf';

interface UseTermsPdfPreloadReturn {
  isReady: boolean;
  isPending: boolean;
  isError: boolean;
}

/**
 * @param enabled hold the request until the tenant config says which document applies
 * @param url the terms document to preload (defaults to the Novus PDF)
 */
export const useTermsPdfPreload = (enabled = true, url: string = TERMS_PDF_URL): UseTermsPdfPreloadReturn => {
  const { isSuccess, isPending, isError } = useQuery({
    queryKey: [TERMS_PDF_QUERY_KEY, url],
    queryFn: () => fetchTermsPdf(url),
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return { isReady: isSuccess, isPending, isError };
};
